


































































































































import Vue from 'vue'
import VueRouter from 'vue-router'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/personalBook'
import { MetaInfo } from 'vue-meta/types/vue-meta'

export default Vue.extend({
  name: 'PersonalBook2',
  data () {
    return {
      hasError: false,
      isLoading: false,
      isEnableValidation: false,
      bookInfo: {
        name: '' as string,
        faceType: 0,
        traitSelected: '00000000',
        materialSelected: 0,
        cover: 2,
        backgroundSelected: 0,
        message: '' as string,
        imagePath: '' as string
      },
      backgroundOptions: [
      ] as string[],
      backgroundCarouselImage: [
      ] as string[]
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '想說的話',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    screenAspectRatio (): number {
      return window.screen.width / window.screen.height
    },
    traitSelectedCount (): number {
      let num = 0
      for (const item of this.bookInfo.traitSelected) {
        if (item === '1') {
          num++
        }
      }
      return num
    }
  },
  created () {
    postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.BACKGROUND)
    window.navigateBack = () => this.$router.go(-1)
    this.loadBookInfoFromLocalStorage()
    this.setBackgroundImage()
  },
  methods: {
    validateMessageEmoji (target: string | number | null | undefined) {
      if (this.isEnableValidation) {
        // Emoji
        if (typeof (target) === 'string' && (target.match(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g))) {
          this.hasError = true
          return false
        }
        return true
      }
      return null
    },
    validateMessage (target: string | number | null | undefined) {
      if (this.isEnableValidation) {
        const reg = new RegExp(/[^\u44a9\u4507\u4E00-\u9FFF\u3105-\u3126\u02ca\u02c7\u02cb\u02d9a-zA-Z0-9 \u3000\n~!@#$%^&*()_+-=?<>\u005c\u002f\uff0f\uff3c\uff0c\u3002\u3001\uff1a\uff01\uff1f\uff1b\uff08\uff09\u300c\u300d\u3010\u3011\uff20\uff03\uff04\uff05\uff3e\uff06\uff0a\u2212\uff0b\uff1d\uff21-\uff3a\uff41-\uff5a]/, 'g')
        if (typeof (target) === 'string' && (reg.test(target))) {
          this.hasError = true
          return target.match(reg)
          // return reg.exec(target)
        }
        return ''
      }
      return ''
    },
    validateMessageEmpty (target: string | number | null | undefined) {
      if (this.isEnableValidation) {
        if (target === null || target === undefined) {
          this.hasError = true
          return false
        }

        if (typeof (target) === 'string' && target.length === 0) {
          this.hasError = true
          return false
        }
        return true
      }
      return null
    },
    onBackgroundImageClicked (index: number) {
      if (index < 0) return
      this.bookInfo.backgroundSelected = index
      this.saveBookInfoToLocalStorage()
    },
    saveBookInfoToLocalStorage () {
      localStorage.setItem('bookInfo', JSON.stringify({
        name: this.bookInfo.name,
        faceType: this.bookInfo.faceType || 0,
        traitSelected: this.bookInfo.traitSelected,
        materialSelected: this.bookInfo.materialSelected || 0,
        cover: this.bookInfo.cover === undefined ? 2 : this.bookInfo.cover,
        backgroundSelected: this.bookInfo.backgroundSelected || 0,
        message: this.bookInfo.message,
        imagePath: this.bookInfo.imagePath
      }))
    },
    loadBookInfoFromLocalStorage () {
      const dataString = localStorage.getItem('bookInfo') || ''
      if (dataString) {
        const data = JSON.parse(dataString)
        if (data.name.length === 0 || data.traitSelected.length === 0 || data.traitSelected === '00000000') {
          this.$router.replace({ name: 'PersonalBook' })
        }
        this.bookInfo.name = data.name
        this.bookInfo.faceType = data.faceType
        this.bookInfo.traitSelected = data.traitSelected
        this.bookInfo.materialSelected = data.materialSelected
        this.bookInfo.cover = data.cover
        this.bookInfo.backgroundSelected = data.backgroundSelected
        this.bookInfo.message = data.message
        this.bookInfo.imagePath = data.imagePath
      } else {
        this.$router.replace({ name: 'PersonalBook' })
      }
    },
    setBackgroundImage () {
      this.backgroundOptions.push('https://nuphoto.com.tw/personalbook/assets/background_option0_' + this.bookInfo.faceType + '.jpg')
      this.backgroundOptions.push('https://nuphoto.com.tw/personalbook/assets/background_option1_' + this.bookInfo.faceType + '.jpg')
      this.backgroundOptions.push('https://nuphoto.com.tw/personalbook/assets/background_option2_' + this.bookInfo.faceType + '.jpg')
      this.backgroundOptions.push('https://nuphoto.com.tw/personalbook/assets/background_option3_' + this.bookInfo.faceType + '.jpg')
      this.backgroundCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/background_img0_' + this.bookInfo.faceType + '.jpg')
      this.backgroundCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/background_img1_' + this.bookInfo.faceType + '.jpg')
      this.backgroundCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/background_img2_' + this.bookInfo.faceType + '.jpg')
      this.backgroundCarouselImage.push('https://nuphoto.com.tw/personalbook/assets/background_img3_' + this.bookInfo.faceType + '.jpg')
    },
    async onPreviewClicked () {
      this.isLoading = true
      this.saveBookInfoToLocalStorage()
      this.isEnableValidation = true

      // Invoke in next tick to wait for isEnableValidation change and all input states change
      this.$nextTick(async () => {
        let validationOverall = true // The result of all validations clear
        const errorStack = []

        // Validate message
        if (!(this.validateMessageEmoji(this.bookInfo.message))) {
          errorStack.push('無法使用表情符號。')
          validationOverall = false
        } else if (this.validateMessage(this.bookInfo.message) !== '') {
          errorStack.push('以下文字不支援。')
          errorStack.push(this.validateMessage(this.bookInfo.message))
          validationOverall = false
        }

        // Collect error messages and show them once
        const messageVNode = []
        for (const e of errorStack) {
          messageVNode.push(this.$createElement('p', { class: ['text-center', 'mt-2', 'mb-0'] }, e))
        }

        // Show the message if validation failed then return
        if (validationOverall === false) {
          this.isLoading = false
          this.$bvModal.msgBoxOk(messageVNode, {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
        } else if (!this.validateMessageEmpty(this.bookInfo.message)) {
          this.isLoading = false
          this.$bvModal.msgBoxConfirm('您尚未輸入想說的話，是否仍要繼續？', {
            centered: true,
            noCloseOnBackdrop: true,
            noCloseOnEsc: true,
            footerClass: 'msgbox-confirm-footer',
            cancelTitle: '否',
            okTitle: '是'
          }).then((result) => {
            if (result) {
              this.isLoading = true
              this.preparePreview()
            }
          })
        } else {
          this.preparePreview()
        }
      })
    },
    preparePreview () {
      const pre = [
        'https://nuphoto.com.tw/personalbook/assets/preview/cover_pre' + this.bookInfo.cover + '_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_48_' + this.bookInfo.backgroundSelected + '_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_1_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_2.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_3.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_4.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_5.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_6_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_7_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_8_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_9_' + this.bookInfo.faceType + '.jpg',
        'https://nuphoto.com.tw/personalbook/assets/preview/book_10_' + this.bookInfo.faceType + '.jpg'
      ]

      const imageContainer = document.getElementById('image-container')
      for (const i in pre) {
        let preImg = document.getElementById('pp-img' + i) as HTMLImageElement
        if (!preImg) {
          console.log('createElement')
          preImg = document.createElement('img')
          preImg.id = 'pp-img' + i
          if (imageContainer) {
            imageContainer.appendChild(preImg)
          }
        }
        preImg.src = pre[i]
      }

      setTimeout(() => {
        for (const i in pre) {
          const preImg = document.getElementById('pp-img' + i) as HTMLImageElement
          if (preImg) {
            if (!preImg.complete) {
              this.preparePreview()
              return
            }
          }
        }

        if (imageContainer) {
          imageContainer.innerHTML = ''
        }

        this.$router.push({ name: 'BookPreview', query: this.$route.query }).catch(error => {
          if (!VueRouter.isNavigationFailure(error, VueRouter.NavigationFailureType.redirected)) {
            this.$bvModal.msgBoxConfirm(`${error.message}是否要再次嘗試？`, {
              centered: true,
              noCloseOnBackdrop: true,
              noCloseOnEsc: true,
              footerClass: 'msgbox-confirm-footer',
              cancelTitle: '否',
              okTitle: '是'
            }).then((result) => {
              if (result) this.onPreviewClicked()
            })
          }
        })
        this.isLoading = false
      }, 250)
    }
  }
})
